<template>
  <div class="question-main-wap">
    <Header class="m-wap" :extras="extras" platform="wap"></Header>
    <div class="m-score-all-wap">
      得分：<span>{{ getScore }}</span
      >/<strong>{{ totalScore }}</strong>
    </div>
    <div v-for="(field, index) in resultList" :key="field.fieldName">
      <div
        class="question-result-item-wap question"
        v-if="field.fieldLevel != 1 && field.fieldLevel != 2 && field.isShow"
      >
        <div class="result-title">
          <div class="question-item-title">{{ field.title }}</div>
          <div class="mark-box-wap" v-if="field.score">
            <span>{{ field.isCorrect == 1 ? field.score : 0 }}</span
            >/<strong>{{ field.score }}</strong>
          </div>
        </div>

        <!-- 描述 BEGIN -->
        <!--<div class="question-item-text" v-if="field.type ==12">-->
        <!--<div class="native-body">{{answers}}</div>-->
        <!--</div>-->
        <!-- 描述 END -->

        <!-- 分割线 BEGIN -->
        <hr v-if="field.type == 13" class="u-hr" />
        <!-- 分割线 END -->

        <!-- 单选题开始 -->
        <ul
          v-if="(field.type == 1 || field.type == 5) && field.isShow"
          class="question-result-option"
        >
          <li
            v-for="o in field.optionsContent"
            :key="o.id"
            class="r-radio"
            :class="{
              'item-ok': o.isSelect == 1,
              'item-err': o.selected == 1 && !(o.isSelect == 1),
            }"
          >
            <input
              type="radio"
              :id="'radio' + index + o.id"
              :checked="o.selected == 1"
              disabled
            />
            <label :for="'radio' + index + o.id">
              <div class="item-ques-content">
                {{ o.name }}
              </div>
              <span
                :class="{
                  'icon-ok': o.isSelect == 1,
                  'icon-err': o.selected == 1 && !(o.isSelect == 1),
                }"
              ></span>
            </label>
          </li>
        </ul>
        <!-- 单选题结束 -->

        <!-- 多选题开始 -->
        <ul
          v-if="(field.type == 2 || field.type == 6) && field.isShow"
          class="question-result-option"
        >
          <li
            v-for="o in field.optionsContent"
            :key="o.id"
            class="r-checkbox"
            :class="{
              'item-ok': o.isSelect == 1,
              'item-err': o.selected == 1 && !(o.isSelect == 1),
            }"
          >
            <input
              type="checkbox"
              :id="'checkbox' + index + o.id"
              :checked="o.selected == 1"
              disabled
            />
            <label :for="'checkbox' + index + o.id">
              <div class="item-ques-content">
                {{ o.name }}
              </div>
              <span
                :class="{
                  'icon-ok': o.isSelect == 1,
                  'icon-err': o.selected == 1 && !(o.isSelect == 1),
                }"
              ></span>
            </label>
          </li>
        </ul>
        <!-- 多选题结束 -->

        <!-- 单选图片开始 -->
        <ul
          v-if="field.type == 9 && field.isShow"
          class="question-result-option"
        >
          <li
            v-for="o in field.optionsContent"
            :key="o.id"
            class="r-radio"
            :class="{
              'item-ok': o.isSelect == 1,
              'item-err': o.selected == 1 && !(o.isSelect == 1),
            }"
          >
            <input
              type="radio"
              :id="'radio' + index + o.id"
              :checked="o.selected == 1"
              disabled
            />
            <label :for="'radio' + index + o.id">
              <div class="m-cont">
                <img class="result-img-wap" :src="o.picUrl" alt="" />
                <span class="item-ques-content">
                  {{ o.name }}
                </span>
              </div>
              <span
                :class="{
                  'icon-ok': o.isSelect == 1,
                  'icon-err': o.selected == 1 && !(o.isSelect == 1),
                }"
              ></span>
            </label>
          </li>
        </ul>
        <!-- 单选图片结束 -->

        <!-- 多选图片开始 -->
        <ul
          v-if="field.type == 10 && field.isShow"
          class="question-result-option"
        >
          <li
            v-for="o in field.optionsContent"
            :key="o.id"
            class="r-checkbox"
            :class="{
              'item-ok': o.isSelect == 1,
              'item-err': o.selected == 1 && !(o.isSelect == 1),
            }"
          >
            <input
              type="checkbox"
              :id="'checkbox' + index + o.id"
              :checked="o.selected == 1"
              disabled
            />
            <label :for="'checkbox' + index + o.id">
              <div class="m-cont">
                <img class="result-img-wap" :src="o.picUrl" alt="" />
                <span class="item-ques-content">
                  {{ o.name }}
                </span>
              </div>
              <span
                :class="{
                  'icon-ok': o.isSelect == 1,
                  'icon-err': o.selected == 1 && !(o.isSelect == 1),
                }"
              ></span>
            </label>
          </li>
        </ul>
        <!-- 多选图片结束 -->

        <!-- 单行填空题开始 -->
        <div v-if="field.type == 4 && field.isShow" class="question-item-text">
          <div v-if="field.enableRegular != 1">
            正确答案：{{ field.answer }}
          </div>
          <div>填写内容：{{ field.answers }}</div>
        </div>
        <!-- 单行填空题结束 -->
      </div>
    </div>
  </div>
</template>

<script>
import templateMixin from "../../../mixins/exam-config";
import resultMixin from "../../../mixins/result";
import ruleMixin from "../../../mixins/exam-result-rules";
export default {
  name: "examWapResult",
  mixins: [templateMixin, resultMixin, ruleMixin],
};
</script>

<style scoped>
.item-ok {
  border: 1px solid #0ace94;
}
.item-err {
  border: 1px solid red;
}
</style>
